// Generated by CoffeeScript 1.11.1
(function() {
  var ChannelImage, LazyExecute;

  ChannelImage = require('../channel_image');

  LazyExecute = require('../lazy_execute');

  module.exports = {
    parseChannelImage: function() {
      var image;
      image = new ChannelImage(this.file, this.header, this);
      return this.image = new LazyExecute(image, this.file).now('skip').later('parse').get();
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer/channel_image.js
// module id = 53
// module chunks = 0